import {
  TIME_AFTERNOON,
  TIME_LUNCH,
  TIME_MORNING,
} from '../../shared/constants'

export const timeOfDayMissionsMapInitial = {
  [TIME_MORNING]: 0,
  [TIME_LUNCH]: 0,
  [TIME_AFTERNOON]: 0,
}
export const dayOfWeekMissionsMapInitial = {
  'Monday': 0,
  'Tuesday': 0,
  'Wednesday': 0,
  'Thursday': 0,
  'Friday': 0,
  'Saturday': 0,
  'Sunday': 0,
}

export const dayMarks = [
  {
    value: 0,
    label: 'Mon',
  },
  {
    value: 1,
    label: 'Tue',
  },
  {
    value: 2,
    label: 'Wed',
  },
  {
    value: 3,
    label: 'Thu',
  },
  {
    value: 4,
    label: 'Fri',
  },
  {
    value: 5,
    label: 'Sat',
  },
  {
    value: 6,
    label: 'Sun',
  },
]

export const timeMarks = [
  {
    value: 1,
    label: '1:00',
  },
  {
    value: 2,
    label: '2:00',
  },
  {
    value: 3,
    label: '3:00',
  },
  {
    value: 4,
    label: '4:00',
  },
  {
    value: 5,
    label: '5:00',
  },
  {
    value: 6,
    label: '6:00',
  },
  {
    value: 7,
    label: '7:00',
  },
  {
    value: 8,
    label: '8:00',
  },
  {
    value: 9,
    label: '9:00',
  },
  {
    value: 10,
    label: '10:00',
  },
  {
    value: 11,
    label: '11:00',
  },
  {
    value: 12,
    label: '12:00',
  },
  {
    value: 13,
    label: '13:00',
  },
  {
    value: 14,
    label: '14:00',
  },
  {
    value: 15,
    label: '15:00',
  },
  {
    value: 16,
    label: '16:00',
  },
  {
    value: 17,
    label: '17:00',
  },
  {
    value: 18,
    label: '18:00',
  },
  {
    value: 19,
    label: '19:00',
  },
  {
    value: 20,
    label: '20:00',
  },
  {
    value: 21,
    label: '21:00',
  },
  {
    value: 22,
    label: '22:00',
  },
  {
    value: 23,
    label: '23:00',
  },
  {
    value: 24,
    label: '24:00',
  },
]

export const COLORS_SCALE = [
  { label: 'High foot-traffic density', color: '#FF6F6F' },
  { label: 'Medium foot-traffic density', color: '#F9F36C' },
  { label: 'Low foot-traffic density', color: '#A2E947' },
]
